// Types
import type { I_it4GetIMEIStatus, I_it4GetIMEIStatus_Return } from "./it4GetIMEIStatus.types";

// Libs
import axios from "../configRequest";
// Data
import { I_AXIOS } from "../configRequest.model";

/**
 * Зарегистрировать IMEI устройства
 * 12.2 документация ru 1.0.5 (d1b82f5)
 * */
export const it4GetIMEIStatus: I_it4GetIMEIStatus = async (payload) => {
    const imeiStatusData = await axios.get<I_it4GetIMEIStatus_Return>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/device/update/${payload.id}`,
        {
            headers: {
                Accept: "application/json;charset=UTF-8",
            },
            params: {
                token: payload.token,
            },
        },
    );
    // console.log(imeiStatusData.data);
    return imeiStatusData.data;
};

export default it4GetIMEIStatus;
